'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { FC, ReactNode } from 'react'

export interface NavLinkProps {
  to: string
  children: ReactNode | ((props: { isActive: boolean }) => ReactNode)
  className?: string | ((props: { isActive: boolean }) => string)
  onClick?: () => void
  [key: string]: any
}

/**
 * NavLink component for Next.js - provides active state like React Router's NavLink
 */
export const NavLink: FC<NavLinkProps> = ({
  to,
  children,
  className,
  onClick,
  ...props
}) => {
  const pathname = usePathname()
  const isActive = !!(pathname === to || pathname?.startsWith(to + '/'))

  const resolvedClassName =
    typeof className === 'function' ? className({ isActive }) : className
  const resolvedChildren =
    typeof children === 'function' ? children({ isActive }) : children

  const hrefValue = to || '#'

  return (
    <Link href={hrefValue} className={resolvedClassName} onClick={onClick} {...props}>
      {resolvedChildren}
    </Link>
  )
}
